const OPTIONS = [
  {
    key: "a",
    label: "Option A — Fraunces Italic",
    tag: "Current · heritage, artisan",
    style: {
      fontFamily: "'Fraunces', serif",
      fontStyle: "italic",
      fontWeight: 700,
      fontVariationSettings: '"SOFT" 100, "WONK" 1, "opsz" 144',
      letterSpacing: "-0.02em",
    },
  },
  {
    key: "b",
    label: "Option B — Bricolage Grotesque",
    tag: "Modern, distinctive, sharp",
    style: {
      fontFamily: "'Bricolage Grotesque', sans-serif",
      fontWeight: 800,
      letterSpacing: "-0.04em",
    },
  },
  {
    key: "c",
    label: "Option C — Instrument Serif Italic",
    tag: "Elegant, editorial",
    style: {
      fontFamily: "'Instrument Serif', serif",
      fontStyle: "italic",
      fontWeight: 400,
      letterSpacing: "-0.01em",
    },
  },
  {
    key: "d",
    label: "Option D — Cormorant Garamond",
    tag: "Classic, refined luxury",
    style: {
      fontFamily: "'Cormorant Garamond', serif",
      fontStyle: "italic",
      fontWeight: 700,
      letterSpacing: "-0.01em",
    },
  },
  {
    key: "e",
    label: "Option E — Bodoni Moda",
    tag: "High-fashion, bold contrast",
    style: {
      fontFamily: "'Bodoni Moda', serif",
      fontWeight: 700,
      letterSpacing: "-0.01em",
    },
  },
];

export default function BrandPreview() {
  return (
    <div className="pt-32 pb-24 bg-[#fafafa] min-h-screen">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="label-eyebrow mb-4">Brand Type Preview</div>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tighter mb-4">
          Pick your K-Walk wordmark.
        </h1>
        <p className="text-[#666] max-w-xl mb-16">
          Same brand, five typographic personalities. Reply "use A" (or B / C / D / E) and I'll
          apply it everywhere.
        </p>

        <div className="space-y-16">
          {OPTIONS.map((o) => (
            <div
              key={o.key}
              className="border border-[#e5e5e5] bg-white p-10 md:p-16"
              data-testid={`brand-option-${o.key}`}
            >
              <div className="flex items-baseline justify-between flex-wrap gap-3 mb-8">
                <div>
                  <div className="font-display text-xs uppercase tracking-widest text-[#666]">
                    {o.tag}
                  </div>
                  <div className="font-display text-lg font-bold mt-1">{o.label}</div>
                </div>
                <div className="text-xs uppercase tracking-widest text-[#666]">
                  Reply "use {o.key.toUpperCase()}"
                </div>
              </div>

              {/* Big display sample */}
              <div style={o.style} className="text-6xl md:text-8xl leading-none text-[#111]">
                K-Walk
              </div>

              {/* Navbar-size sample */}
              <div className="mt-10 pt-8 border-t border-[#e5e5e5] flex items-center gap-8 flex-wrap">
                <span className="text-xs uppercase tracking-widest text-[#666]">
                  Navbar size:
                </span>
                <div style={o.style} className="text-3xl leading-none text-[#111]">
                  K-Walk
                </div>
                <span className="text-xs uppercase tracking-widest text-[#666]">
                  Footer size:
                </span>
                <div style={o.style} className="text-xl leading-none text-[#111]">
                  K-Walk
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-24 text-center text-sm text-[#666]">
          Not seeing anything you like? Send me a font name or Google Fonts link and I'll add it as
          a 6th option.
        </div>
      </div>
    </div>
  );
}
